<template>
    <div class="custom-made-page">
        <div class="img">
            <img src="../assets/custom_made_2.png" />
            <img src="../assets/custom_made.png" />
        </div>
        <div class="desc" v-if="lang == 'fr'">
            <h1>Sur mesure</h1>
            Nous pouvons aussi répondre à toute demande

            particulière de taille, quantité, couleur, ou

            encore personnalisation de vos paires de gants

            mais ce sous réserve d'une quantité minimum

            garantie.

            Pour toute commande particulière de cet

            ordre, merci de prendre directement contact

            avec la société

            AIM - LES GANTS D’AMÉLIE
            <ul>
                <li>par mail en <a href="mailto:contact@lesgantsdamelie.com">Cliquant ici</a></li>

                <li>par téléphone au <a href="tel:+33142880011">0033 (0)1 42 88 00 11</a></li>

                <li>par fax au 0033 (0)1 45 25 68 49</li>

                <li>par courrier : 9 rue de la Tour, 75116 Paris</li>
            </ul>
        </div>
        <div class="desc" v-if="lang == 'en'">
            <h1>Custom Made</h1>
            <p>
                Although we proudly meet any specific request

                in size, quantity, color or customization, we

                have a minimum quantity condition.

                For any particular order of this kind, please

                contact us directly :

                AIM - LES GANTS D’AMÉLIE
                <ul>
                    <li>by email, just <a href="mailto:contact@lesgantsdamelie.com">Click here</a></li>

                    <li>by phone, dial <a href="tel:+33142880011">0033 (0)1 42 88 00 11</a></li>

                    <li>by fax, dial 0033 (0)1 45 25 68 49</li>

                    <li>by mail : 9 rue de la Tour, 75116 Paris</li>
                </ul>
            </p>
        </div>

    </div>
</template>

<script>
  export default {
    name: 'custom-made-page',
    props: ['lang'],
  };
</script>
<style lang="scss">
    .custom-made-page {
        display: flex;
        animation: fadeIn 1s;

        align-items: stretch;
        @media screen and (max-width:768px){
            flex-direction: column;
        }

        .img, .desc {
            flex: 40% 0;
        }
        @media screen and (max-width:768px) {
            .img {
                text-align: center;
            }
            .desc {margin:auto;}
        }
        @media screen and (min-width:768px) {
            .desc {
                margin-top:10rem;
            }
            .img {
                text-align: right;
                margin-right: 1rem;
                margin-top: 5rem;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/CustomMadePage.vue